<template>
  <de-layout-content>
    <div class="app-container">
      <div class="question_box dark-theme">
        <template v-if="!is_finish">
          <div class="quesTitle">《{{ questionTitle }}》</div>
          <div class="question_content">
            <div class="title">共{{ questionList.length }}题,已完成{{ finish }}题</div>
            <div class="sub_title">指导语：{{ questionDetail.explainInfo }}</div>
            <div class="question_lists" v-if="questionList && questionList.length > 0">
              <Topic :selectItemS="selectItemS" :topicData="questionList" @reset="reset" @submit="submit"
                @change="change" />
            </div>
          </div>
        </template>
        <template v-else>
          <a-empty :image="complete_img" :description="'今日已完成该问卷'" />
        </template>
      </div>
    </div>
  </de-layout-content>
</template>

<script>
import Topic from '../../workBench/components/Topic.vue';
import * as API_Ques from "@/api/dataAccess/questionnaire";
export default {
  components: {
    Topic
  },
  data() {
    return {
      selectItemS: {},
      // userType: this.$store.state.loginInfo.type,  //用户类型
      userId: this.$route.query.id, //用户id
      queBatch: this.$route.query.queBatch,
      questionTitle: '',
      questionType: '',
      questionList: [],
      questionData: [{
        title: '今日感觉疲劳程度',
        type: 'slider',
        answer: '',
        slider_marks: {
          1: '很轻松',
          10: '极限'
        }
      }, {
        title: '今日感觉疲劳程度(1-10级)',
        type: 'radio',
        answer: '',
        options: [{
          label: '轻松',
          value: 1
        }, {
          label: '一般',
          value: 2
        }, {
          label: '极限',
          value: 3
        }]
      }, {
        title: '你今日的训练目的是什么',
        type: 'textarea',
        answer: '',
        placeholder: '请输入内容'
      }, {
        title: '今日感觉疲劳程度121',
        type: 'slider',
        answer: '',
        slider_marks: {
          1: '很轻松',
          10: '极限'
        }
      }, {
        title: '今日感觉疲劳程度113331',
        type: 'slider',
        answer: '',
        slider_marks: {
          1: '很轻松',
          10: '极限'
        }
      }, {
        title: '今日感觉疲劳程度1432411',
        type: 'slider',
        answer: '',
        slider_marks: {
          1: '很轻松',
          10: '极限'
        }
      }],
      finish: 0,
      is_finish: false,
      complete_img: require("@/assets/xxp-img/ywc.png"),
      questionDetail: {}
    }
  },
  methods: {
    reset(form) {
      for (let key in form) {
        form[key].answer = '';
      }
    },
    submit(data) {
      // console.log(data)
      if (this.questionType == 1 && this.finish < data.length) {
        this.$message.error('未回答完')
        return
      } else if (this.finish < 1) {
        this.$message.error('未回答完')
        return
      }
      let params = []
      data.map(item => {
        let answer_arr = []
        let answer_body = [{
          type: 'forward',
          keyPoints: []
        }, {
          type: 'back',
          keyPoints: []
        }]
        if (item.topicType == 3) {//多选，拼数据结构，后端要求的
          item.answer.map(res => {
            let obj = { answerId: res }
            answer_arr.push(obj)
          })
        } else if (item.topicType == 4) {  //人体图
          answer_body.map(ele => {
            let arr = []
            item.answer[ele.type].map(items => {
              arr.push(items.No)
            })
            ele.keyPoints = arr
          })
        }
        let obj = {
          topicType: item.topicType,
          queType: this.questionType,
          queId: item.id,
          answer: item.topicType == 4 ? JSON.stringify(answer_body) : ([2].includes(item.topicType) ? JSON.stringify([{ answerId: item.answer }]) : (item.topicType == 3 ? JSON.stringify(answer_arr) : item.answer))
        }
        params.push(obj)
      })
      // console.log(params)
      API_Ques.queaddAnswer(params).then(res => {
        if (res.code == 200) {
          this.$message.success('提交成功')
          this.$router.back()
        }
      })
    },
    change(data) {
      if (data && data.length > 0) {
        let i = 0;
        data.forEach((item, index) => {
          if (item.topicType == 4) {  //人体图
            if (item.answer.forward && item.answer.forward.length > 0 || item.answer.back && item.answer.back.length > 0) {
              i++
            }
          } else {
            if (item.answer && item.answer != '') {
              i++
            }
          }
        })
        this.finish = i;
      }
    },

    // 没有答题-进入渲染
    getQuestion() {
      let param = {
        queType: this.questionType,
        userId: this.userId
      }
      API_Ques.queFindQue(param).then(res => {
        if (res.code == 200) {
          console.log('getQuestion')
          console.log(res.data)

          res.data.queBankVos.map(item => {
            item.answer = Array.isArray(item.answers) ? item.answers[0].answerId : item.answer ? item.answer : ''
            item.disabled = false
          })

          this.questionDetail = res.data
          this.questionList = res.data.queBankVos
          this.questionList.forEach((ele, i) => {
            if (ele.topicType == 1) {
              ele.slider_marks = {}
              ele.sliderMaxVal = null
              ele.optionVos.forEach((element, index) => {
                ele.slider_marks[index + 1] = element.remark
                ele.sliderMaxVal = index + 1
              })
            }
          });
          this.selectItemS = res.data.queBankVos.filter(item => item.topicType === 4)
          // this.finish = res.data.queBankVos.length
          this.is_finish = false
        } else {
          this.is_finish = true
          this.$message.success(res.msg)
        }
      })
    },
    // 没有答题-进入渲染-end

    // 答题完成-进入渲染-start
    getInfo() {
      let param = {
        queBatch: this.queBatch,
        // userId: this.userId
      }
      API_Ques.findQueInfo(param).then(res => {
        if (res.code == 200) {
          console.log('getInfo')
          console.log(res.data)
          res.data.queBankVoList.map(item => {
            item.answer = Array.isArray(item.answers) ? item.answers[0].answerId : item.answer ? item.answer : ''
            item.disabled = true
          })
          this.questionDetail = res.data
          this.questionList = res.data.queBankVoList
          this.questionList.forEach((ele, i) => {
            if (ele.topicType == 1) {
              ele.slider_marks = {}
              ele.sliderMaxVal = null
              ele.optionVos.forEach((element, index) => {
                ele.slider_marks[index + 1] = element.remark
                ele.sliderMaxVal = index + 1
              })
            }
          });
          this.finish = res.data.queBankVoList.length
          this.selectItemS = res.data.queBankVoList.filter(item => item.topicType === 4)
          this.is_finish = false
        } else {
          this.is_finish = true
          this.$message.success(res.msg)
        }
      })
    }
    // 答题完成-进入渲染-end
  },
  created() {
    this.questionTitle = this.$route.query.questionTitle
    this.questionType = this.$route.query.type
    if (this.queBatch) {
      this.getInfo()
      return
    } else {
      this.getQuestion()
    }
  }
}
</script>

<style lang="less" scoped>
.question_box {
  // width: 80%;
  height: 80%;
  padding: 40px;

  .quesTitle {
    font-size: 20px;
    width: 100%;
    text-align: center;
    font-weight: bold;
    margin-bottom: 30px;
  }

  // background: #1C2242;
  .question_content {
    width: 80%;
    padding-bottom: 40px;

    .title {
      font-size: 20px;
      font-weight: 700;
      color: #38c5bc;
    }

    .sub_title {
      font-size: 14px;
      font-weight: 400;
      color: #bcbcbc;
      line-height: 1.4;
      margin: 16px 0 32px 0;
    }
  }
}
</style>